import { APIError } from '../APIError';
import { CredentialSchema, Subscriptions } from '../types';

type SetSchemaAction = {
  type: 'set_credential_schema';
  schemas: Array<CredentialSchema>;
};

type SetSchemaLoadingAction = {
  type: 'set_credential_schema_loading';
  loading: boolean;
};

type SetSubscriptionsAction = {
  type: 'set_subscriptions';
  subscriptions: Array<Subscriptions>;
};

type SetSchemaError = {
  type: 'set_credential_schema_error';
  err: APIError;
};

export type CredentialAction =
  | SetSchemaAction
  | SetSchemaError
  | SetSchemaLoadingAction
  | SetSubscriptionsAction;

export const CREDENTIAL_ACTIONS = {
  SET_SUBSCRIPTIONS: (
    subscriptions: Array<Subscriptions>,
  ): SetSubscriptionsAction => ({
    type: 'set_subscriptions',
    subscriptions: subscriptions,
  }),
  SET_SCHEMA: (schemas: Array<CredentialSchema>): SetSchemaAction => ({
    type: 'set_credential_schema',
    schemas,
  }),
  SET_SCHEMA_LOADING: (loading: boolean): SetSchemaLoadingAction => ({
    type: 'set_credential_schema_loading',
    loading,
  }),
  SET_ERROR: (err: APIError): SetSchemaError => ({
    type: 'set_credential_schema_error',
    err,
  }),
};
